import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useParams} from 'react-router-dom';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = ({ customerId, billingProviderId }: { customerId?: string; billingProviderId?: string }) => {
    const urlCustomerId = useParams().id;
    const finalCustomerId = customerId || urlCustomerId;

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader customerId={finalCustomerId} billingProviderId={billingProviderId}/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable customerId={finalCustomerId} billingProviderId={billingProviderId}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
